import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
          <div>
            <h3 className="text-2xl font-heading font-semibold mb-6">Kontakt</h3>
            <div className="space-y-3 text-sm leading-relaxed">
              <p>
                Tel:{' '}
                <a href="tel:023515691455" className="underline hover:text-background-100 transition-colors">
                  02351 5691455
                </a>
              </p>
              <p>Fax: 02351 5691456</p>
              <p>
                Mobil:{' '}
                <a href="tel:01752412769" className="underline hover:text-background-100 transition-colors">
                  0175 2412769
                </a>
              </p>
              <p>
                E-Mail:{' '}
                <a
                  href="mailto:info@klosek-metallbau.de"
                  className="underline hover:text-background-100 transition-colors"
                >
                  info@klosek-metallbau.de
                </a>
              </p>
            </div>

            <div className="mt-8">
              <h4 className="text-lg font-heading font-semibold mb-4">
                Öffnungszeiten
              </h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between max-w-xs">
                  <span>Mo - Do</span>
                  <span>7:00 - 18:00</span>
                </div>
                <div className="flex justify-between max-w-xs">
                  <span>Freitag</span>
                  <span>7:00 - 16:00</span>
                </div>
                <div className="flex justify-between max-w-xs">
                  <span>Sa - So</span>
                  <span>Nur nach Vereinbarung</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-heading font-semibold mb-6">Anfahrt</h3>
            <p className="text-sm mb-4">
              Hier finden Sie uns:
            </p>
            <p className="text-sm font-medium mb-4">
              Römerweg 15<br />
              58513 Lüdenscheid, DE
            </p>
            <div className="w-full h-48 md:h-56 rounded-lg overflow-hidden bg-background-100/10">
              <iframe
                title="Anfahrt Klosek Metallbau"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2500.0!2d7.60133!3d51.25181!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDE1JzA2LjUiTiA3wrAzNicwNC44IkU!5e0!3m2!1sde!2sde!4v1700000000000!5m2!1sde!2sde"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link
                to="/agb"
                className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium border border-background-50/40 rounded-md hover:bg-background-50/10 transition-colors"
              >
                AGB
              </Link>
              <Link
                to="/datenschutz"
                className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium border border-background-50/40 rounded-md hover:bg-background-50/10 transition-colors"
              >
                Datenschutz
              </Link>
              <Link
                to="/impressum"
                className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium border border-background-50/40 rounded-md hover:bg-background-50/10 transition-colors"
              >
                Impressum
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/20">
        <div className="w-full px-4 md:px-6 lg:px-8 py-5 text-center text-sm opacity-80">
          Klosek Metallbau GmbH — Römerweg 15, 58513 Lüdenscheid
        </div>
      </div>
    </footer>
  );
}